import { render, staticRenderFns } from "./PlacementsStartComponentPerformanceItemMilestone.vue?vue&type=template&id=5db6b8e5&"
import script from "./PlacementsStartComponentPerformanceItemMilestone.vue?vue&type=script&lang=js&"
export * from "./PlacementsStartComponentPerformanceItemMilestone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports